import React from 'react';
import { useChangelog } from './useChangelog';

export const Changelog: React.FC<React.PropsWithChildren> = ({ children }) => {
  useChangelog();

  return <>{children}</>;
};
